export default __webpack_public_path__ + "static/control-tab-ea02189ee3ebd1a76ad44abfdcaa1a31.svg";